import React, { Component } from 'react';

class ChartFooter extends Component {
    
    getUpdateText = () => {
        if (this.props.showUpdate === true){
            return (
            
                <div className="chart-header-flex">
                    <div className="chart-footer-spacing">
                        <p className="chart-footer-text">{this.props.drillText}</p>
                    </div>
                    <div className="chart-footer-spacing">
                        <p className="chart-footer-text">{this.props.updatedText}</p>
                    </div>
                </div>
            )
        } else {
            return (<div></div>) 
        }
    }
    
    render() { 
        return ( 
            <React.Fragment>
                {this.getUpdateText()}
            </React.Fragment>
         );
    }
}
 
export default ChartFooter;